module.exports = __webpack_public_path__ + "static/media/pricingAction3x.67a1ba4f.png";